import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const UserRoundX: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M2 21a8 8 0 0 1 11.873-7' }],
    ['circle', { cx: '10', cy: '8', r: '5' }],
    ['path', { d: 'm17 17 5 5' }],
    ['path', { d: 'm22 17-5 5' }],
  ],
];

export default UserRoundX;
